import { render, staticRenderFns } from "./PostalField.vue?vue&type=template&id=15b02d46"
import script from "./PostalField.vue?vue&type=script&lang=js"
export * from "./PostalField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports